module.exports = __webpack_public_path__ + "img/40.f7ee46eb.png";